module.exports = __webpack_public_path__ + "img/14_38.0986e2de.png";